export default __webpack_public_path__ + "static/media/034-black star.d7e44d10.svg";